import Util from '../_utils/util'

const nativeUtil = {
    openContent(url, data) {
        if(!url) {
            return
        }
        if (/MSOHU/i.test(window.navigator.userAgent) && window.Panther) {
            const urlObj = Util.parseURL(url)
            const spmCode = urlObj.spm || ''
            const scmCode = urlObj.scm || ''
            const regMatch = /\/(a|picture)\/(\d+)(_\d+\?|\?)/.test(url)
            const authorId = data.authorId || data.authId
            if(RegExp.$1 === 'a') {
                // 匹配文章页
                if(typeof Panther.openNewsContent === 'function' ) {
                    Panther.openNewsContent(RegExp.$2, spmCode, scmCode, authorId)
                }else {
                    window.location.href = url
                }
            }else if(RegExp.$1 === 'picture') {
                // 匹配图集页
                if(typeof Panther.openImageSet === 'function' ) {
                    Panther.openImageSet(Number(RegExp.$2), spmCode, scmCode, authorId)
                }else {
                    window.location.href = url
                }
            }else {
                window.location.href = url
            }
        } else {
            window.location.href = url
        }
    }
}

export default nativeUtil


// WEBPACK FOOTER //
// ./src/_utils/native-util.js